import React from 'react';
import './About.css';
import Footer from '../../../components/layout/Footer/Footer';
import Header from '../../../components/layout/Header/Header';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="about-page">
                      <div className="classjustforheadercolor"></div>

      <Header />
      
      {/* Hero Split Section */}
      <section className="about-hero">
        {/* Left Side - Content */}
        <div className="about-hero__left">
          <div className="hero-content">
            <div className="hero-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
              <span>Depuis 2008</span>
            </div>

            <h1 className="about-hero__title">
              Créateurs d'Espaces de <span className="title-highlight">Travail Exceptionnels</span>
            </h1>

            <p className="about-hero__subtitle">
              Plus qu'un simple fournisseur de mobilier, nous sommes vos partenaires 
              dans la création d'environnements de travail inspirants et productifs.
            </p>

            <p className="hero-description">
              Depuis plus de 15 ans, BuroTime façonne l'avenir du mobilier de bureau 
              en Algérie avec passion, innovation et un engagement indéfectible envers 
              l'excellence et la satisfaction client.
            </p>

            <div className="hero-actions">
              <Link to="/products" className="btn-primary">
                Découvrir nos produits
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
              <Link to="/contact" className="btn-outline">
                Nous contacter
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Right Side - Image Collage */}
        <div className="about-hero__right">
          <div className="image-collage">
            <div className="collage-item collage-item--large">
              {/* Placeholder for image */}
              <div style={{
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #C6A667, #D4B67E)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
            </div>
            <div className="collage-item">
              <div style={{
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #E52421, #ED504D)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
            </div>
            <div className="collage-item">
              <div style={{
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #2E2E2E, #4A4A4A)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#C6A667" strokeWidth="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Stats Overlay */}
          <div className="stats-overlay">
            <div className="stat-box">
              <div className="stat-box__number">15+</div>
              <div className="stat-box__label">Années d'Expérience</div>
            </div>
            <div className="stat-box">
              <div className="stat-box__number">2,500+</div>
              <div className="stat-box__label">Projets Réalisés</div>
            </div>
            <div className="stat-box">
              <div className="stat-box__number">98%</div>
              <div className="stat-box__label">Clients Satisfaits</div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="story-grid">
            <div className="story-content">
              <span className="section-badge">Notre Histoire</span>
              <h2 className="story-content__title">
                Une Passion Devenue Excellence
              </h2>
              <p className="story-content__text">
                Fondée en 2008, BuroTime est née d'une vision simple mais ambitieuse : 
                transformer les espaces de travail algériens en environnements modernes, 
                ergonomiques et inspirants. Aujourd'hui, nous sommes fiers d'être l'un 
                des leaders du secteur.
              </p>
              <p className="story-content__text">
                Notre succès repose sur trois piliers fondamentaux : la qualité 
                exceptionnelle de nos produits, l'innovation constante dans nos designs, 
                et un service client irréprochable qui place vos besoins au centre de 
                tout ce que nous faisons.
              </p>

              <div className="story-highlights">
                <div className="highlight-item">
                  <div className="highlight-item__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                  </div>
                  <div className="highlight-item__content">
                    <h4>Qualité Certifiée</h4>
                    <p>Tous nos produits respectent les normes internationales ISO 9001</p>
                  </div>
                </div>

                <div className="highlight-item">
                  <div className="highlight-item__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M12 6v6l4 2"/>
                    </svg>
                  </div>
                  <div className="highlight-item__content">
                    <h4>Livraison Rapide</h4>
                    <p>Installation professionnelle dans toute l'Algérie sous 48h</p>
                  </div>
                </div>

                <div className="highlight-item">
                  <div className="highlight-item__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                  </div>
                  <div className="highlight-item__content">
                    <h4>Garantie 5 Ans</h4>
                    <p>Une garantie complète qui témoigne de notre confiance en nos produits</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="story-image">
              <div style={{
                width: '100%',
                height: '600px',
                background: 'linear-gradient(135deg, #C6A667, #E8DCC4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="1">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9 22 9 12 15 12 15 22"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Nos Valeurs</span>
            <h2 className="section-header__title">Ce Qui Nous Définit</h2>
            <p className="section-header__subtitle">
              Des principes fondamentaux qui guident chacune de nos actions et 
              renforcent notre engagement envers l'excellence.
            </p>
          </div>

          <div className="values-grid">
            <div className="value-card">
              <div className="value-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                  <line x1="12" y1="22.08" x2="12" y2="12"/>
                </svg>
              </div>
              <h3 className="value-card__title">Innovation</h3>
              <p className="value-card__description">
                Nous repoussons constamment les limites du design et de la fonctionnalité 
                pour créer des solutions qui anticipent les besoins de demain.
              </p>
            </div>

            <div className="value-card">
              <div className="value-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <h3 className="value-card__title">Excellence</h3>
              <p className="value-card__description">
                Chaque produit que nous créons incarne notre quête de perfection, 
                de la conception à la livraison finale.
              </p>
            </div>

            <div className="value-card">
              <div className="value-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
                </svg>
              </div>
              <h3 className="value-card__title">Service Client</h3>
              <p className="value-card__description">
                Votre satisfaction est notre priorité absolue. Notre équipe dédiée 
                est toujours à votre écoute pour vous accompagner.
              </p>
            </div>

            <div className="value-card">
              <div className="value-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 16v-4M12 8h.01"/>
                </svg>
              </div>
              <h3 className="value-card__title">Transparence</h3>
              <p className="value-card__description">
                Des prix clairs, des délais respectés, une communication honnête. 
                La confiance se construit sur la transparence.
              </p>
            </div>

            <div className="value-card">
              <div className="value-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                </svg>
              </div>
              <h3 className="value-card__title">Durabilité</h3>
              <p className="value-card__description">
                Nous créons des produits durables qui respectent l'environnement 
                et résistent à l'épreuve du temps.
              </p>
            </div>

            <div className="value-card">
              <div className="value-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3 className="value-card__title">Fiabilité</h3>
              <p className="value-card__description">
                Une garantie de 5 ans sur tous nos produits témoigne de notre 
                confiance en la qualité de notre travail.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Notre Équipe</span>
            <h2 className="section-header__title">Les Visages Derrière BuroTime</h2>
            <p className="section-header__subtitle">
              Une équipe passionnée et dévouée, prête à donner vie à vos projets 
              les plus ambitieux.
            </p>
          </div>

          <div className="team-grid">
            <div className="team-member">
              <div className="team-member__avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <h4 className="team-member__name">Karim Benali</h4>
              <p className="team-member__role">Fondateur & CEO</p>
              <p className="team-member__bio">
                Visionnaire passionné par l'innovation et l'excellence
              </p>
            </div>

            <div className="team-member">
              <div className="team-member__avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <h4 className="team-member__name">Yasmine Khelifi</h4>
              <p className="team-member__role">Directrice Design</p>
              <p className="team-member__bio">
                Créatrice de solutions esthétiques et fonctionnelles
              </p>
            </div>

            <div className="team-member">
              <div className="team-member__avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <h4 className="team-member__name">Mehdi Larbi</h4>
              <p className="team-member__role">Directeur Commercial</p>
              <p className="team-member__bio">
                Expert en relation client et développement commercial
              </p>
            </div>

            <div className="team-member">
              <div className="team-member__avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <h4 className="team-member__name">Fatima Amrani</h4>
              <p className="team-member__role">Chef de Projet</p>
              <p className="team-member__bio">
                Gestionnaire méthodique garantissant l'excellence
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-card__content">
              <h2 className="cta-card__title">
                Prêt à Transformer Votre Espace de Travail?
              </h2>
              <p className="cta-card__description">
                Contactez-nous dès aujourd'hui pour une consultation gratuite et 
                découvrez comment nous pouvons créer l'environnement de travail 
                parfait pour votre entreprise.
              </p>
              <div className="cta-actions">
                <Link to="/contact" className="btn-white">
                  Demander un Devis
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
                <Link to="/products" className="btn-ghost">
                  Voir le Catalogue
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;